export default __webpack_public_path__ + "static/media/IV 2025.bbcd72a4.pdf";